var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticClass: "columns" }, [
      _c(
        "div",
        { staticClass: "column" },
        [
          _c(
            "b-field",
            { attrs: { label: _vm.$t("pages.plants.forecast.range_date") } },
            [
              _c("b-datepicker", {
                attrs: {
                  value: _vm.rangeDates,
                  inline: "",
                  placeholder: "Click to select...",
                  range: "",
                },
                on: {
                  input: function ($event) {
                    return _vm.$emit("rangeDates", $event)
                  },
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "column" },
        [
          _c(
            "b-field",
            { attrs: { label: _vm.$t("pages.plants.forecast.working_days") } },
            [
              _c(
                "b-checkbox",
                {
                  attrs: { value: _vm.allowSaturday },
                  on: {
                    input: function ($event) {
                      return _vm.$emit("allowSaturday", $event)
                    },
                  },
                },
                [_vm._v(" " + _vm._s(_vm.$t("global.saturday")) + " ")]
              ),
              _c(
                "b-checkbox",
                {
                  attrs: { value: _vm.allowSunday },
                  on: {
                    input: function ($event) {
                      return _vm.$emit("allowSunday", $event)
                    },
                  },
                },
                [_vm._v(" " + _vm._s(_vm.$t("global.sunday")) + " ")]
              ),
            ],
            1
          ),
          _c("b-button", {
            attrs: {
              "icon-left": "save",
              label: _vm.$t("pages.plants.forecast.save_working_days"),
              type: "is-primary",
            },
            on: {
              click: function ($event) {
                return _vm.$emit("save")
              },
            },
          }),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }